import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { GoogleAuthProvider, signInWithPopup, getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { useEffect } from "react";
import Swal from "sweetalert2";

const axios = require("axios");

const firebaseConfig = {
  apiKey: "AIzaSyBONfS7CcPywYyT7GqIFviticozA4a3htI",
  authDomain: "skillludo-7a7fa.firebaseapp.com",
  projectId: "skillludo-7a7fa",
  storageBucket: "skillludo-7a7fa.firebasestorage.app",
  messagingSenderId: "643008544284",
  appId: "1:643008544284:web:f61c3c187cf78254b4a9d9",
  measurementId: "G-CGYTX2EDC7"
};
// BASE URL

const baseUrl = process.env.REACT_APP_API_BASE_URL;
// +++++++++++++++++++++++++++++ 
const access_token = localStorage.getItem("token");
const fcm1 = localStorage.getItem("udata");
const fcm = JSON.parse(fcm1);
export const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

const db = getFirestore(app);

export const getTokens = async () => {
  const lastPrompt = localStorage.getItem("fcmPromptedAt");
  const twelveHours = 12 * 60 * 60 * 1000;

  // If no token and permission not yet granted, and popup not shown in last 12h
  if (
    !fcm?.firebaseToke &&
    Notification.permission !== "granted" &&
    (!lastPrompt || Date.now() - Number(lastPrompt) > twelveHours)
  ) {
    const result = await Swal.fire({
      title: "Allow Notifications",
      text: "To receive important updates, please allow notifications.",
      icon: "info",
    });

    // Store prompt timestamp regardless of decision
    localStorage.setItem("fcmPromptedAt", Date.now().toString());

    // If user denied, stop further execution

  }
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BJkIxbWYd9yZGRhTNwlftCPuEBxZOyDuwK2MTag-6YAUfmgS7jPE8HaprqgvYUFoWADD4zEFC2eKXLxaPoqhvoA",
    });

    if (currentToken) {
      if (access_token && fcm?.firebaseToken !== currentToken) {
        const headers = {
          Authorization: `Bearer ${access_token}`,
        };
        try {
          const res = await axios.get(
            baseUrl + `updateToken?firebaseToken=${currentToken}`,
            { headers }
          );
          console.log(res);
          localStorage.setItem("fcm", currentToken);
        } catch (e) {
          console.log(e);
        }
      }
    } else {
      console.log(
        "No registration token available. Request permission to generate one."
      );
    }
  } catch (err) {
    // console.log(err);
  }
};

getTokens();
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
      console.log(payload);
    });
  });

// async function loginWithGoogle() {
//     try {
//         const provider = new GoogleAuthProvider();
//         const auth = getAuth();

//         const { user } = await signInWithPopup(auth, provider);

//         return { uid: user.uid, displayName: user.displayName };
//     } catch (error) {
//         if (error.code !== 'auth/cancelled-popup-request') {
//             console.error(error);
//         }

//         return null;
//     }
// }
// const provider=JSON.parse(localStorage.getItem('provider'));
//console.log(provider?.provider_data?.id)
// async function sendMessage(roomId, user, text) {
//     try {
//         await addDoc(collection(db, 'chatRoom', roomId, 'chats'), {
//             //   uid: user.uid,
//             //   displayName: user.displayName,
//             //   text: text.trim(),
//             //   timestamp: serverTimestamp(),
//             uid: user?.data?.id || null,
//             displayName: user?.data?.display_name || null,
//             user_type:user?.data?.user_type,
//             reciver_id:provider?.provider_data?.id,
//             text: text.trim(),
//             timestamp: serverTimestamp(),
//         });

//     } catch (error) {
//         console.error(error);
//     }
// }

// function getMessages(roomId, callback) {
//     return onSnapshot(
//         query(
//             collection(db, 'chatRoom', roomId, 'chats'),
//             orderBy('timestamp', 'asc')
//         ),
//         (querySnapshot) => {
//             const messages = querySnapshot.docs.map((doc) => ({
//                 id: doc.id,
//                 ...doc.data(),
//             }));
//             console.log(messages)
//             callback(messages);
//         }
//     );
// }


